class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.openTimer = null;

    // hover events
    this.addEventListener('mouseenter', () => {
      if (this.header) {
        const headerHeight = this.header.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      }
      this.openTimer = setTimeout(() => {
        // remove the open attributes to all other mainDetailsToggle elements
        document.querySelectorAll('details[open]').forEach((el) => {
          if (el !== this.mainDetailsToggle) {
            el.removeAttribute('open');
            el.querySelector('summary').setAttribute('aria-expanded', false);
          }
        });
        this.onToggle();
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
        this.mainDetailsToggle.setAttribute('open', '');
        _.addClass(document.documentElement, 'overflow-hidden');
      }, 150); // small delay to allow for hover intent
    });

    this.addEventListener('mouseleave', (event) => {
      clearTimeout(this.openTimer);
      // if the mouse moves to another .header__inline-menu-item element close the menu
      if (event.relatedTarget && event.relatedTarget.closest('.header__inline-menu-item')) {
        _.removeClass(document.documentElement, 'overflow-hidden');
        this.close();
      }
    });

    this.content.addEventListener('mouseleave', (event) => {
      clearTimeout(this.openTimer);

      this.closeTimer = setTimeout(() => {
        if (!this.contains(event.relatedTarget)) {
          _.removeClass(document.documentElement, 'overflow-hidden');
          this.close();
        }
      }, 200); // slight buffer to move between summary and panel
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define('header-menu', HeaderMenu);
